import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import LocalProfileValidators from '../shared/local-profile-validators';
import AttributeValueType from 'app/models/enums/AttributeValueType';

type BusinessCitationProviderAttribute = Boo.BusinessCitations.Models.BusinessCitationProviderAttribute;

@Injectable({
  providedIn: 'root'
})
export class LocalProfileAttributeFormFactory {
  constructor(private formBuilder: FormBuilder) { }

  createFormControl(attribute: BusinessCitationProviderAttribute): FormGroup {
    switch (attribute.ValueType) {
      case AttributeValueType.Boolean:
        return this.formBuilder.group({
          DisplayName: [attribute.DisplayName],
          ExternalId: [attribute.ExternalId],
          ValueType: [attribute.ValueType],
          Value: ["true", LocalProfileValidators.attributeValidator(attribute)],
          ValueMetadata: [attribute.ValueMetadata]
        });
      case AttributeValueType.RepeatedEnum:
        var repeatedEnumGroup = this.formBuilder.group({
          DisplayName: [attribute.DisplayName],
          ExternalId: [attribute.ExternalId],
          ValueType: [attribute.ValueType],
          Value: [attribute.Value],
          ValueMetadata: [attribute.ValueMetadata],
          SelectedEnums: [attribute.Value?.split(',') ?? [], LocalProfileValidators.attributeValidator(attribute)]
        });
        return repeatedEnumGroup;
      default:
        return this.formBuilder.group({
          DisplayName: [attribute.DisplayName],
          ExternalId: [attribute.ExternalId],
          ValueType: [attribute.ValueType],
          Value: [attribute.Value, LocalProfileValidators.attributeValidator(attribute)],
          ValueMetadata: [attribute.ValueMetadata]
        });
    }
  }

  createFormArray(attributes: BusinessCitationProviderAttribute[]): FormArray<FormGroup> {
    return this.formBuilder.array(attributes.map(attribute => this.createFormControl(attribute)));
  }
}